module FormButtons
{
	export function construct()
	{
		$("[data-sets]").click((event) => {
			const parameters = $(event.target).data("sets").split(",");
			const target = $(parameters[0]);
			const value = parameters[1] as string;
			target.val(value);
		});

		$("[data-submits]").click((event) => {
			const element = $(event.target);
			$(element.data("submits")).submit();
		});
	}
}